<template>
  <div v-loading="loading" element-loading-text="数据加载中..." style="height: 100%;width: 100%">
    <el-container style="height: 100%;width: 100%">
      <el-main style="padding: 0;width:100%;height: 100%;margin-left: 2px;overflow-x: hidden;overflow-y: hidden">
        <div style="display: flex;flex-direction: row;">
          <div style="margin-left: 5px;margin-top: 2px">
            <el-select style="width: 225px;" @change="clickThing(wujianId)" v-model="wujianId" filterable clearable
                       placeholder="物件名称">
              <el-option v-for="item in things" :key="item.id" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>

          <div class="border center" style="text-align: left;width: 100%;margin-left: 5px;">
            <el-button size="small" class="week" style="margin-left: 20px" @click="clickThisWeek">{{ $t('makeSchedule.paintingProductionScheduling.thisWeek') }}</el-button>
            <el-button size="small" class="week" @click="clickLastWeek">
              <el-icon>
                <ElIconArrowLeft/>
              </el-icon>
              {{ $t('makeSchedule.paintingProductionScheduling.lastWeek') }}
            </el-button>
            <el-date-picker size="small" v-model="week" format="M月-D日" value-format="MM-DD" type="daterange"
                            disabled range-separator="~" style="width: 180px;"/>
            <el-button size="small" class="week" @click="clickNextWeek">{{ $t('makeSchedule.paintingProductionScheduling.afterWeek') }}
              <el-icon>
                <ElIconArrowRight/>
              </el-icon>
            </el-button>
            <span style="margin-left: 20px">{{ $t('makeSchedule.paintingProductionScheduling.version') }}：</span>

            <el-select v-model="versionIdx" style="width: 150px;" @change="queryCalendarLineData" filterable
                       :placeholder="$t('makeSchedule.paintingProductionScheduling.versionNumber')">
              <el-option v-for="item in versionIdxs" :key="item.id" :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
            <!--            <el-button size="small" style="width: 60px;margin-left: 10px" type="warning" :loading="exportDataBool"-->
            <!--                       @click="exportAssemblyRecordData">导出-->
            <!--            </el-button>-->
          </div>

        </div>
        <div v-if="draggableBool" ref="total_height" style="display: flex;height: 94%;width: auto;overflow-x: auto">
          <!--            第一个-->
          <div class="total_style" v-for="item in state.dataList" :key="item">
            <div class="border color time" :style="item.expireTimeClass">
              <div>{{ item.time }}</div>
              <div>{{ item.week }}</div>
            </div>
            <div v-if="!item.line_bool" :class="!item.line_bool?'prompt data_style1':''" :style="maxHeight">
              产线未开
            </div>
            <div v-if="item.line_bool" class="data_style">
              <div v-for="lineCnt in item.line_cnt" :key="lineCnt" class="data_style2"
                   :style="item.expireTimeClass">
                <div class="data_style3">
                  <span v-if="lineCnt.dayShiftCnt == 'powder'" style="background-color: burlywood" class="data_style4">&nbsp;粉体&nbsp;</span>
                  <span v-if="lineCnt.dayShiftCnt == 'liquid'" style="background-color: #0486fe" class="data_style4">&nbsp;液体&nbsp;</span>
                  <span v-if="lineCnt.dayShiftCnt == 'pretreatment'" style="background-color: #2bd82f" class="data_style4">&nbsp;前处理&nbsp;</span>
                  <!--                  <span v-if="lineCnt.nightShiftCnt == 'powder'" style="background-color: burlywood" class="data_style4_1">&nbsp;粉体&nbsp;</span>-->
                  <!--                  <span v-if="lineCnt.nightShiftCnt == 'liquid'" style="background-color: #0486fe" class="data_style4_1">&nbsp;液体&nbsp;</span>-->
                  <!--                  <span v-if="lineCnt.nightShiftCnt == 'pretreatment'" style="background-color: #2bd82f" class="data_style4_1">&nbsp;前处理&nbsp;</span>-->
                </div>
                <div v-if="lineCnt.remark != '' && lineCnt.remark != undefined" class="item">
                  <el-row>
                    <el-col :span="24">
                      <el-tooltip class="custom-tooltip" :content="lineCnt.remark" placement="top">
                        <div v-if="lineCnt.remark" class="overflow-text" style="height: 100%;color:black;">
                          {{ lineCnt.remark }}
                        </div>
                      </el-tooltip>
                    </el-col>
                  </el-row>
                </div>
                <div>
                  <draggable :style="lineCnt.height" :class="lineCnt.class_line_name" :list="lineCnt.lineData"
                             ghost-class="ghost" chosen-class="chosenClass" handle=".move" animation="300"
                             :sort="true" group="group">
                    <template #item="{ element }">
                      <div class="item">
                        <el-row style="border-bottom: #0478e4 2px solid">
                          <el-col :span="24">
                            <span>{{ element.wujian_short_name }}&nbsp;-&nbsp;</span>
                            <span>{{ element.floor }}F&nbsp;-&nbsp;</span>
                            <span>{{ paint_type_name[element.paint_type] }}</span>
                          </el-col>
                          <div style="margin-top: -22px;margin-left: 92%;">
                                <span @click="splitBatchItem(item.time,lineCnt,element)" class="cursor"
                                      style="font-size: 14px;"><el-icon><ElIconMoreFilled/></el-icon></span>
                          </div>
                        </el-row>

                        <el-row
                            :style="lineCnt.dayShiftCnt == 'powder' || lineCnt.dayShiftCnt == 'liquid' ||  lineCnt.nightShiftCnt == 'powder' || lineCnt.nightShiftCnt == 'liquid'?'border-bottom: #0478e4 2px solid':''">
                          <el-col v-for="batchNo in element.batchData" :key="batchNo" :span="12">
                            <div>{{ batchNo }}</div>
                          </el-col>
                        </el-row>
                        <el-row
                            v-if="lineCnt.dayShiftCnt == 'powder' || lineCnt.dayShiftCnt == 'liquid' ||  lineCnt.nightShiftCnt == 'powder' || lineCnt.nightShiftCnt == 'liquid'">
                          <el-col v-for="color in element.colorData" :key="color" :span="12">
                            <div>{{ color }}</div>
                          </el-col>
                        </el-row>
                      </div>
                    </template>
                  </draggable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>

  <el-dialog title="详情" v-model="splitBatchItemBool" width="60%">
    <el-form :model="formWujianData" label-width="100px">
      <el-row>
        <el-col :span="24">
          <div style="text-align: center;font-size: 30px;height: 50px">{{ formWujianData.wujian_short_name }}</div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="楼层信息：">
            <el-input v-model="formWujianData.floor" disabled placeholder="楼层信息" style="width: 90%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="排产日期：">
            <el-date-picker v-model="formWujianData.production_scheduling_date" disabled type="date"
                            placeholder="排产日期" style="width: 90%"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="排产产线：">
            <div v-if="!lineBool && formWujianData.lineCnt == 'powder'" class="border"
                 style="height: 30px;line-height:30px;text-align: center;background-color: #0486fe;color: white;">粉体
            </div> <!--  白班-->
            <div v-if="!lineBool && formWujianData.lineCnt == 'liquid'" class="border"
                 style="height: 30px;line-height:30px;text-align: center;background-color: #0486fe;color: white;">液体
            </div> <!--  白班-->
            <div v-if="!lineBool && formWujianData.lineCnt == 'pretreatment'" class="border"
                 style="height: 30px;line-height:30px;text-align: center;background-color: #0486fe;color: white;">前处理
            </div> <!--  白班-->
            <!--            <div v-if="lineBool && formWujianData.lineCnt == 'powder'" class="border" style="height: 30px;line-height:30px;text-align: center;background-color: #223342;color: white;">粉体夜班</div> &lt;!&ndash;  夜班&ndash;&gt;-->
            <!--            <div v-if="lineBool && formWujianData.lineCnt == 'liquid'" class="border" style="height: 30px;line-height:30px;text-align: center;background-color: #223342;color: white;">液体夜班</div> &lt;!&ndash;  夜班&ndash;&gt;-->
            <!--            <div v-if="lineBool && formWujianData.lineCnt == 'pretreatment'" class="border" style="height: 30px;line-height:30px;text-align: center;background-color: #223342;color: white;">前处理夜班</div> &lt;!&ndash;  夜班&ndash;&gt;-->
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="排产批号：">
            <el-select style="width: 95%;" v-model="formWujianData.newBatchNoList" disabled multiple filterable
                       clearable placeholder="物件名称">
              <el-option v-for="item in this.batchNoList" :key="item.id" :label="item.batch_no + ' - ' + item.color"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>
</template>
<script>
import draggable from "vuedraggable";
import moment from "moment";

export default {
  name: "PaintingProductionSchedulingRecord",
  components: {draggable},
  data() {
    return {
      startDate: '',
      endDate: '',
      startTime: '',
      endTime: '',
      things: [],
      wujianId: '',
      versionIdx: '',
      versionIdxs: [],
      thingName: '',
      state: {
        dataList: [],
      },
      week: [], //时间组件数据
      weekList: [], //一个星期的时间
      splitBatchItemBool: false, //控制物料详情页面
      formWujianData: {},
      batchNoList: [],//修改前的批号数据
      lineBool: false,//false表示白班 true表示夜班
      loading: false,
      versionIdxBool: false,
      exportDataBool: false,
      draggableBool: false,
      maxHeight: "",//获取页面的最大高度
      paint_type_name: {
        'ft': '粉体',
        'fs': '液体',
        'acl': '共通'
      },
    }
  }, methods: {
    getWuJianInFo() {
      this.$axios.post('mfg/wujianPlan/getWujianName').then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("获取数据失败");
        }

        this.things = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    async queryCalendarLineData() {
      if (!this.versionIdx) {
        return this.$message.error("版本号为空");
      }

      if (!this.wujianId) {
        return this.$message.error("物件为空");
      }

      if (!this.startTime) {
        return this.$message.error("开始时间为空");
      }

      if (!this.endTime) {
        return this.$message.error("结束时间为空");
      }

      if (!this.weekList) {
        return this.$message.error("week时间为空");
      }
      this.versionIdxBool = true;
      this.draggableBool = true;
      this.loading = true;
      let params = {
        wujianId: this.wujianId,
        startTime: this.startTime,
        endTime: this.endTime,
        weekList: this.weekList,
        versionIdx: this.versionIdx
      };
      await this.$axios.post('mfg/paintingProductionRecord/queryCalendarLineData', params).then(response => {
        this.loading = false;
        this.versionIdxBool = false;
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        console.log("22222", res.data)
        this.state.dataList = res.data;
        setTimeout(() => {
          this.getMaxHeight();
        }, 200);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    exportAssemblyRecordData() {
      if (!this.versionIdx) {
        return this.$message.error("版本号不能为空");
      }

      this.exportDataBool = true;
      let params = {
        wujianId: this.wujianId,
        startTime: this.startTime,
        endTime: this.endTime,
        versionIdx: this.versionIdx
      };
      this.$axios.post('mfg/paintingProductionRecord/exportAssemblyRecordData', params).then(response => {
        let res = response.data
        this.exportDataBool = false;
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }
        console.log("res:==", res)
        const url = res.data.url;
        const originalName = res.data.originalName;
        if (url) {
          const link = document.createElement('a');
          link.href = url;
          link.download = originalName || '' // 下载文件的名字
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        }
        return this.$message.success("导出成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    async getVersionIdx() {
      if (!this.wujianId) {
        return this.$message.error("物件为空");
      }

      if (!this.startTime) {
        return this.$message.error("开始时间为空");
      }

      if (!this.endTime) {
        return this.$message.error("结束时间为空");
      }
      this.versionIdx = '';
      this.versionIdxBool = true;
      let params = {wujianId: this.wujianId, startTime: this.startTime, endTime: this.endTime};
      await this.$axios.post('mfg/paintingProductionRecord/getVersionIdx', params).then(response => {
        this.loading = false;
        this.versionIdxBool = false;
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        if (!res.data) {
          this.versionIdxs = res.data;
          this.$message.error("未找到版本号");
        } else {
          console.log("getVersionIdx=", res)
          this.versionIdxs = res.data;
          this.versionIdx = this.versionIdxs[this.versionIdxs.length - 1].value
          return this.$message.success("版本号查询成功");
        }
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    //物件计划详情
    splitBatchItem(time, lineCnt, element) {
      this.batchNoList = element.newBatchNoList;
      this.formWujianData = {};
      this.splitBatchItemBool = true;
      let cnt;
      if (lineCnt.dayShiftCnt) {
        cnt = lineCnt.dayShiftCnt;
        this.lineBool = false;
      } else {
        cnt = lineCnt.nightShiftCnt;
        this.lineBool = true;
      }

      this.formWujianData.paint_type = element.newBatchNoList[0].paint_type
      this.formWujianData.wujian_short_name = element.wujian_short_name;
      this.formWujianData.floor = element.floor;
      this.formWujianData.newBatchNoList = [];
      for (let batchNo of element.newBatchNoList) {
        this.formWujianData.newBatchNoList.push(batchNo.id)
      }
      this.formWujianData.form_className = lineCnt.class_line_name;
      this.formWujianData.wujian_id = element.wujian_id;
      this.formWujianData.lineCnt = cnt;
      let timeString = time.toString().substring(0, time.toString().length - 1);
      let timeList = timeString.toString().split("月");
      let month = timeList[0];
      let day = timeList[1];
      if (month < 10) {
        month = '0' + month;
      }

      if (day < 10) {
        day = '0' + day;
      }
      let date;
      //特殊处理跨年的
      if (this.startTime.substring(0,4) !== this.endTime.substring(0,4)) {
        if (parseInt(month) < 12) { //这是下一年
          date = this.endTime.substring(0,4) + '-' + month + '-' + day;
        } else {
          date = this.startTime.substring(0,4) + '-' + month + '-' + day;
        }
      } else {
        date = this.startTime.substring(0,4) + '-' + month + '-' + day;
      }
      this.formWujianData.production_scheduling_date = date;
      //console.log("formWujianData=", this.formWujianData)
    },
    async clickThing(wujianId) {
      this.draggableBool = false;
      this.versionIdx = '';
      for (let item of this.things) {
        if (item.value === wujianId) {
          this.thingName = item.label;
        }
      }
      await this.getVersionIdx();
      await this.queryCalendarLineData()
    },
    //本周
    async clickThisWeek() {
      let obj = this.getCurrWeekDays();
      this.formatTime(obj.startTime, obj.endTime);
      this.draggableBool = false;
      await this.getVersionIdx();
      await this.queryCalendarLineData()
    },
    //上周
    async clickLastWeek() {
      let obj = this.getLastWeekDays(this.startTime, this.endTime);
      this.formatTime(obj.startTime, obj.endTime);
      this.draggableBool = false;
      await this.getVersionIdx();
      await this.queryCalendarLineData()
    },
    //下周
    async clickNextWeek() {
      let obj = this.getBelowWeekDays(this.startTime, this.endTime);
      this.formatTime(obj.startTime, obj.endTime);
      this.draggableBool = false;
      await this.getVersionIdx();
      await this.queryCalendarLineData()
    },
    // 获取本周开始结束时间
    getCurrWeekDays() {
      let obj = {
        startTime: '',
        endTime: ''
      }

      let endDate = new Date(this.assemblyEndTime); // 结束日期
      obj.startTime = moment(moment().week(moment().week()).startOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD');
      obj.endTime = moment(endDate.valueOf()).format('YYYY-MM-DD');
      return obj
    },
    // 获取上一周的开始结束时间
    getLastWeekDays(startTime, endTime) {
      let obj = {
        startTime: '',
        endTime: ''
      }
      obj.startTime = moment(startTime).add(-7, 'days').format('YYYY-MM-DD');
      obj.endTime = moment(endTime).add(-7, 'days').format('YYYY-MM-DD');
      return obj
    },
    // 获取下一周的开始结束时间
    getBelowWeekDays(startTime, endTime) {
      let obj = {
        startTime: '',
        endTime: ''
      }
      obj.startTime = moment(startTime).add(7, 'days').format('YYYY-MM-DD');
      obj.endTime = moment(endTime).add(7, 'days').format('YYYY-MM-DD');
      return obj
    },
    //处理时间
    formatTime(startTime, endTime) {
      console.log("startTime=", startTime)
      console.log("endTime=", endTime)
      this.startTime = startTime;
      this.endTime = endTime;
      this.week = [];
      this.weekList = [];
      let startDate = moment(startTime).add(-1, 'days');
      let endDate = moment(endTime);
      while (startDate.isBefore(endDate)) {
        startDate.add(1, 'days');
        let date = moment(startDate).format('YYYY-MM-DD')
        let time = moment(date).format('MM') + "月" + moment(date).format('DD') + "日";
        this.weekList.push({time});
      }

      let weeks = ["一", "二", "三", "四", "五", "六", "日"]
      let cnt = 0;
      for (let i = 0; i < this.weekList.length; i++) {
        if (i === 7) {
          cnt = 0;
        }
        this.weekList[i]['week'] = "(" + weeks[cnt] + ")";
        cnt += 1;
      }

      this.startDate = moment(startTime).format('MM') + "-" + moment(startTime).format('DD');
      this.endDate = moment(endTime).format('MM') + "-" + moment(endTime).format('DD');
      this.week.push(this.startDate);
      this.week.push(this.endDate);
    },
    getAssemblyEndTime() {
      let startTime = moment(moment().week(moment().week()).startOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD');
      let endTime = moment(moment().week(moment().week()).endOf('week').add(8, 'days').valueOf()).format('YYYY-MM-DD');
      let params = {startTime: startTime, endTime: endTime};
      this.$axios.post('mfg/paintingProduction/getAssemblyEndTime', params).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("组立最后排产时间为空");
        }

        this.assemblyEndTime = res.data;
        let obj = this.getCurrWeekDays();
        this.formatTime(obj.startTime, obj.endTime);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
        this.loading = false;
      })
    },
    getMaxHeight() {
      var h_max = 0;
      var widthBox = document.getElementsByClassName('data_style');
      for (var i = 0; i < widthBox.length; i++) {
        if (h_max < widthBox[i].clientHeight) {
          h_max = widthBox[i].clientHeight;
        }
      }

      let totalHeight = this.$refs.total_height.clientHeight;
      let timeHeight = totalHeight * 0.06;
      console.log("this.totalHeight=", totalHeight)
      console.log("this.timeHeight=", timeHeight)
      let pageHeight = totalHeight - timeHeight - 15;
      if (h_max < pageHeight) {
        h_max = pageHeight;
      }

      console.log(pageHeight);
      this.maxHeight = "height: " + h_max + "px;";
      console.log("this.maxHeight=", this.maxHeight)
    },
    getStyle2(batchItem) {
      console.log("batchItem==", batchItem)
      if (batchItem.painting_num === 0) {
        return "background-color: #f56c6c";
      }

      if (batchItem.painting_num > 0 && batchItem.painting_num < batchItem.unit_num) {
        return "background-color: #e6a23c";
      }

      if (batchItem.painting_num === batchItem.unit_num) {
        return "background-color: #67c23a";
      }

    },
  }, created() {
    this.getAssemblyEndTime();
    this.getWuJianInFo();
  }
}
</script>

<style scoped>
.border {
  border: rgb(216, 220, 230) 1px solid;
}

.color {
  background-color: rgb(228, 231, 237);
}

.center {
  text-align: center;
  height: 37px;
  line-height: 37px;
}

.cursor {
  cursor: pointer;
}

/*一下是拖拽样式*/
.item {
  border: solid 2px #0478e4 !important;
  font-size: 14px;
  color: black;
  margin-top: 3px;
  height: 100%;
  text-align: center;
  background-color: whitesmoke;
}

.item1 {
  border-top: dashed 1px #a9aeb7 !important;
  font-size: 14px;
  color: black;
  text-align: center;
  background-color: whitesmoke;
}

.chosenClass {
  font-size: 13px;
  font-weight: bold;
}

/*button样式*/
.button {
  color: white;
  border-radius: 5px 5px 0 0;
  width: 100%;
  margin-top: 5px;
}

/*div样式*/
.week {
  border: #909399 0 solid;
  background-color: white;
  color: rgb(4, 134, 254);
}

.total_style {
  width: auto;
  align-items: center;
  margin-left: 5px;
  margin-top: 1px;
}

.time {
  width: 100%;
  height: 47px;
  text-align: center;
  margin-top: 5px;
}

.data_style {
  width: 224px;
  height: auto;
}

.data_style1 {
  width: 224px;
  height: auto;
  background-color: #e7e7e7;
  margin-top: 5px;
  border: rgb(216, 220, 230) 2px solid;
}

.data_style2 {
  margin-top: 5px;
  border: rgb(216, 220, 230) 2px solid;
}

.data_style3 {
  width: 100%;
  background-color: rgb(228, 231, 237);
  color: white;
  text-align: center;
  height: 30px;
  line-height: 30px;
}

.data_style4 {
  background-color: rgb(4, 120, 228);
  font-size: 14px;
}

.data_style4_1 {
  background-color: black;
  margin-left: 2px;
  font-size: 14px;
}

.data_style6 {
  margin-left: 45px;
  color: black;
}

.data_style7 {
  color: rgb(144, 147, 153);
}

.radius {
  border-radius: 50%;
  height: 18px;
  line-height: 18px;
  margin-top: 2px
}


/*动态样式*/
.prompt {
  color: rgba(0, 0, 0, 0.2);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.overflow-text {
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 显示省略号 */
  width: 100%; /* 设置容器的宽度 */
  position: relative; /* 为悬停时显示的提示框做准备 */
}

.custom-tooltip {
  width: 150px; /* 设置提示框的宽度 */
  max-height: 200px; /* 设置提示框的最大高度 */
  overflow-y: auto; /* 如果内容超出高度，显示滚动条 */
}

</style>